export type SendMessageKeymap = "enter" | "shift-enter" | "ctrl-enter" | "none";

export const SEND_MESSAGE_KEYMAP_STORAGE_KEY = "shopexperts.chat.sendMessageKeymap";

const ENTER_TO_SEND_STORAGE_KEY = "shopexperts.chat.enterToSend";

export function isSendMessageKeymap(value: unknown): value is SendMessageKeymap {
  return value === "enter" || value === "shift-enter" || value === "ctrl-enter" || value === "none";
}

export function getInitialSendMessageKeymap(): SendMessageKeymap {
  if (typeof window === "undefined") return "enter";

  const storedKeymap = window.localStorage.getItem(SEND_MESSAGE_KEYMAP_STORAGE_KEY);
  if (isSendMessageKeymap(storedKeymap)) return storedKeymap;

  const legacyEnterToSend = window.localStorage.getItem(ENTER_TO_SEND_STORAGE_KEY);
  if (legacyEnterToSend === "false") return "shift-enter";

  // Touch keyboards have no Shift+Return, so Enter-to-send would leave no way to type a line break.
  return window.matchMedia?.("(pointer: coarse)").matches ? "none" : "enter";
}
